import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
  },
  mutations: {
    loading(state: any, status: boolean) {
      state.loading = status;
    },
  },
  getters: {
    loading: (state) => state.loading,
  },
  actions: {
  },
  modules: {
  },
});
